import { React, useState, useEffect, useContext } from "react";
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import { Link } from "react-router-dom";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import Form from "../../../component/utilities/Forms";
import { Modal, Button } from "react-bootstrap";
import { AuthContext } from "../../../component/context/AuthContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactSwitch from "react-switch";
import * as SwitchProps from "../../../component/utilities/ReactSwitchReactSwitchProps";
import { EditIcon, DeleteIcon } from '../../../component/utilities/ActionIcons';

function ManageSubscriptions() {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [validate, setValidate] = useState({});
  const [subscriptionTypeData, setSubscriptionTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const MySwal = withReactContent(Swal);
  const [action, setAction] = useState("");
  /** For Modalpopup */
  const [show, setShow] = useState(false);
  /* START DATATABLE */
  const [totalRecords, settotalRecords] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);

  //Search
  const [searchSubName, setSearchSubName] = useState("");
  const [searchSubStatus, setSearchSubStatus] = useState("");

  const [dataSort, setSubscriptionTypeDataSort] = useState({
    order: "desc",
    order_by: "id",
  });
  const pageNumberLimit = 10;

  //For Form
  const [subscriptionName, setSubscriptionName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("1");
  const [subscriptionTypeId, setSubscriptionTypeId] = useState(0);
  const [disabled, setDisabled] = useState(false);

  let isToken = "";
  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
    }
  }

  const [searchParam, setSearchParam] = useState({
    srchSubName: searchSubName,
    srchSubStatus: searchSubStatus,
  });

  useEffect(() => {
    fetchSubscriptionData(searchParam, dataSort, activePage, perPage);
  }, [searchParam, dataSort, activePage]);

  function handleShow(action, subTypeId) {
    const sub_id = subTypeId ? subTypeId : 0;
    setSubscriptionName("");
    setDescription("");
    setSubscriptionTypeId(0);
    setStatus("1");

    if (sub_id !== 0) {
      setSubscriptionTypeId(sub_id);
      fetchSubscriptionById(sub_id);
    }
    setAction(action);
    setShow(true);
  }

  async function subscriptionSearch() {
    setSearchParam({
      srchSubName: searchSubName,
      srchSubStatus: searchSubStatus,
    });

    setSubscriptionTypeDataSort({
      order: "desc",
      order_by: "id",
    });

    setActivePage(1);
  }

  function clearSearch() {
    setSearchSubName("");
    setSearchSubStatus("");

    setSearchParam({
      srchSubName: "",
      srchSubStatus: "",
    });

    setSubscriptionTypeDataSort({
      order: "desc",
      order_by: "id",
    });

    setActivePage(1);
  }

  const handleClose = () => {
    setShow(false);
    setSubscriptionTypeId(0);
    setSubscriptionName("");
    setDescription("");
    setStatus("1");
  };

  function deleteHandler(sub_type_id) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this subscription type?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (sub_type_id > 0) {
          setLoading(true);
          axios
            .post(CONST.DELETE_SUBSCRIPTION_TYPE, {
              id: sub_type_id,
            }, {
              headers: {
                Authorization: `Bearer ${isToken}`,
              }
            })
            .then((response) => {
              if (response) {
                if (response.data.status == "error") {
                  toast.error(response.data.message);
                } else {
                  toast.success(response.data.message);
                  fetchSubscriptionData(searchParam, dataSort, activePage, perPage);
                }
              }
            })
            .catch((error) => {
              toast.error("Something went wrong. Please try again.");
            })
            .finally(() => {
              setLoading(false);
            });
        }
      }
    });
  }

  //fetch all Subscription data by id
  async function fetchSubscriptionById(subTypeId) {
    setLoading(true);
    // In many of these pages, there is no specific getById endpoint, 
    // so we might have to find it in the current list or the backend might provide a list with filter.
    // However, I'll assume we can use the list endpoint with an ID filter if available, 
    // or just find it in the current state if we are editing.
    // But for consistency with the pattern, I'll try to find it in subscriptionTypeData.
    const editData = subscriptionTypeData.find(item => item.id === subTypeId);
    if (editData) {
      setSubscriptionName(editData.name || "");
      setDescription(editData.description || "");
      setStatus(editData.is_active || "1");
    }
    setLoading(false);
  }

  //fetch all subscription details
  async function fetchSubscriptionData(
    paramSearch,
    paramSort,
    paramPage,
    paramLimit
  ) {
    setLoading(true);
    await axios
      .get(CONST.GET_SUBSCRIPTION_TYPE_LIST, {
        params: {
          limit: paramLimit,
          page_number: paramPage,
          sort: paramSort,
          srchSubName: paramSearch.srchSubName,
          srchSubStatus: paramSearch.srchSubStatus,
        },
        headers: {
          Authorization: `Bearer ${isToken}`,
        },
      })
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          setSubscriptionTypeData(response.data.data);
          setTotalRows(response.data.count || response.data.data.length);
          settotalRecords(response.data.count || response.data.data.length);
        } else {
          setSubscriptionTypeData([]);
          setTotalRows(0);
          settotalRecords(0);
        }
      })
      .catch((error) => {
        setSubscriptionTypeData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;

    let validator = Form.validator({
      subscriptionName: {
        value: subscriptionName,
        isRequired: true,
        label: "Subscription Name",
      },
    });

    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    }

    if (isValid) {
      let apiUrl = "";
      let sucessMessage = "";
      if (subscriptionTypeId == 0) {
        apiUrl = CONST.ADD_SUBSCRIPTION_TYPE;
        sucessMessage = "Subscription type added successfully";
      } else {
        apiUrl = CONST.EDIT_SUBSCRIPTION_TYPE;
        sucessMessage = "Subscription type updated successfully";
      }

      setDisabled(true);
      setFullLoading(true);
      await axios({
        method: "post",
        url: apiUrl,
        data: {
          id: subscriptionTypeId,
          name: subscriptionName,
          description: description,
          is_active: status,
        },
        headers: {
          Authorization: `Bearer ${isToken}`,
        },
      })
        .then((response) => {
          if (response) {
            if (response.data.status == "error") {
              toast.error(response.data.message || "Something went wrong.");
            } else {
              toast.success(sucessMessage);
              fetchSubscriptionData(searchParam, dataSort, activePage, perPage);
              handleClose();
            }
          }
        })
        .catch((error) => {
          // toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          setFullLoading(false);
          setDisabled(false);
        });
    }
  };

  const handleChangeStatus = (index, status_value, sub_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const newStatus = status_value == "1" ? "0" : "1";
        axios
          .post(
            CONST.EDIT_SUBSCRIPTION_TYPE,
            {
              id: sub_id,
              is_active: newStatus,
            },
            {
              headers: {
                Authorization: `Bearer ${isToken}`,
              },
            }
          )
          .then((response) => {
            const status = response.data.status;
            if (status == "success") {
              toast.success("Status updated successfully");
              const newData = [...subscriptionTypeData];
              newData[index].is_active = newStatus;
              setSubscriptionTypeData(newData);
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            toast.error("There was an error.");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => (activePage - 1) * perPage + index + 1,
      width: "10%",
    },
    {
      name: "Subscription Name",
      selector: (row) => row.name,
      sortable: true,
      width: "25%",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      width: "30%",
    },
    {
      name: "Status",
      width: "15%",
      cell: (row, index) => (
        <ReactSwitch
          onColor={SwitchProps.onColor}
          onHandleColor={SwitchProps.onHandleColor}
          handleDiameter={SwitchProps.handleDiameter}
          uncheckedIcon={SwitchProps.uncheckedIcon}
          checkedIcon={SwitchProps.checkedIcon}
          boxShadow={SwitchProps.boxShadow}
          activeBoxShadow={SwitchProps.activeBoxShadow}
          height={SwitchProps.height}
          width={SwitchProps.width}
          className={SwitchProps.className}
          checked={row.is_active == "1" ? true : false}
          onChange={() => {
            handleChangeStatus(index, row.is_active, row.id);
          }}
        />
      ),
    },
    {
      name: "Action",
      width: "20%",
      cell: (row) => (
        <>
          <EditIcon onClick={() => handleShow("Edit", row.id)} tooltip="Edit" />
          <DeleteIcon onClick={() => deleteHandler(row.id)} tooltip="Delete" />
        </>
      ),
    },
  ];

  const handleSort = async (column, sortDirection) => {
    setSubscriptionTypeDataSort({
      order: sortDirection,
      order_by: column.sortField || "id",
    });
  };

  const handlePageChange = async (page) => {
    setActivePage(parseInt(page));
  };

  const BootyPagination = ({
    rowsPerPage,
    rowCount,
    onChangePage,
    currentPage,
  }) => {
    function toPages(pages) {
      const results = [];
      for (let i = 1; i <= pages; i++) {
        results.push(i);
      }
      return results;
    }
    function getNumberOfPages(rowCount, rowsPerPage) {
      return Math.ceil(rowCount / rowsPerPage);
    }

    const handleBackButtonClick = () => {
      if ((currentPage - 1) % pageNumberLimit === 1) {
        setMaxPageLimit(maxPageLimit - pageNumberLimit);
        setMinPageLimit(minPageLimit - pageNumberLimit);
      }
      onChangePage(currentPage - 1);
    };

    const handleNextButtonClick = () => {
      if (currentPage + 1 > maxPageLimit) {
        setMaxPageLimit(maxPageLimit + pageNumberLimit);
        setMinPageLimit(minPageLimit + pageNumberLimit);
      }
      onChangePage(currentPage + 1);
    };

    const handlePageNumber = (e) => {
      onChangePage(Number(e.target.value));
    };

    const pages = getNumberOfPages(rowCount, rowsPerPage);
    const pageItems = toPages(pages);
    const nextDisabled = currentPage === pageItems.length;
    const previosDisabled = currentPage === 1;

    const pageNumbers = pageItems.map((page) => {
      if (page <= maxPageLimit && page > minPageLimit) {
        return (
          <li
            key={page}
            className={`page-item ${currentPage === page ? "active" : ""}`}
          >
            <button
              className={`page-link ${currentPage === page ? "active" : ""}`}
              onClick={handlePageNumber}
              value={page}
            >
              {page}
            </button>
          </li>
        );
      } else {
        return null;
      }
    });

    return (
      <div className="card-footer d-flex align-items-center">
        <p className="m-0 text-muted">
          Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, rowCount)} of {rowCount} entries
        </p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleBackButtonClick}
              disabled={previosDisabled}
            >
              «
            </button>
          </li>
          {pageNumbers}
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleNextButtonClick}
              disabled={nextDisabled}
            >
              »
            </button>
          </li>
        </ul>
      </div>
    );
  };

  const CustomLoader = () => (
    <div style={{ padding: "24px" }}>
      <DivLoader color="primary" />
    </div>
  );

  return (
    <>
      <Loading
        loading={fullLoading}
        background="rgba(0, 0, 0, 0.5)"
        loaderColor="#fff"
      />
      <HeaderSection
        title="Manage"
        heading="Subscription Type"
        addButton={() => handleShow("Add", 0)}
        addLink="#"
        addLinkName="Add Subscription Type"
        linktype="add"
      />
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Listing</h3>
                </div>
                <div className="card-body border-bottom py-3">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mb-3 ">
                        <label className="form-label">Subscription Name</label>
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            onChange={(e) => setSearchSubName(e.target.value)}
                            value={searchSubName}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="mb-3">
                        <label className="form-label">Status</label>
                        <select
                          className="form-select form-control"
                          onChange={(e) => setSearchSubStatus(e.target.value)}
                          value={searchSubStatus}
                        >
                          <option value="">All</option>
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group mb-3 ">
                        <label className="form-label">&nbsp;</label>
                        <div>
                          <button
                            type="button"
                            className="btn btn-blue d-none d-sm-inline-block mr-3"
                            onClick={subscriptionSearch}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                              <circle cx="10" cy="10" r="7"></circle>
                              <line x1="21" y1="21" x2="15" y2="15"></line>
                            </svg>
                            Search
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={clearSearch}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={subscriptionTypeData}
                    progressPending={loading}
                    progressComponent={<CustomLoader />}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    paginationComponent={BootyPagination}
                    sortServer
                    onSort={handleSort}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal size="lg" show={show} onHide={handleClose} >
        <Modal.Header closeButton>
          <Modal.Title>{action} Subscription Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form method="POST" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label required">Subscription Name</label>
                <input
                  type="text"
                  className={`form-control ${validate.validate && validate.validate.subscriptionName ? "is-invalid" : ""}`}
                  placeholder="Enter Name"
                  onChange={(e) => {
                    setSubscriptionName(e.target.value);
                    if (validate.validate && validate.validate.subscriptionName) {
                      let tempValidate = { ...validate.validate };
                      delete tempValidate.subscriptionName;
                      setValidate({ validate: tempValidate });
                    }
                  }}
                  value={subscriptionName}
                />
                {validate.validate && validate.validate.subscriptionName && (
                  <div className="invalid-feedback">
                    {validate.validate.subscriptionName[0]}
                  </div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label required">Status</label>
                <select
                  className="form-select form-control"
                  onChange={(e) => setStatus(e.target.value)}
                  value={status}
                >
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter Description"
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                ></textarea>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={disabled}>{disabled ? "Submitting..." : "Submit"}</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ManageSubscriptions;
